import type { PermissionCatalog } from '@ztechapps/common.contract'
import { appShellPermissions } from '@ztechapps/common.contract'
import { aiPermissions } from '@ztechapps/ai.common'
import { blogPermissions } from '@ztechapps/blog.common'
import { customerPermissions } from '@ztechapps/customer.common'
import { chatPermissions } from '@ztechapps/chat.common'
import { orderPermissions } from '@ztechapps/order.common'
import { productPermissions } from '@ztechapps/product.common'
import { projectPermissions } from '@ztechapps/project.common'
import { purchaseOrderPermissions } from '@ztechapps/purchase-order.common'
import { returnOrderPermissions } from '@ztechapps/return-order.common'
import { panelpunchesPermissions } from './panelpunchesPermissions'

// Array order is the only display order there is — the modal renders modules in this
// exact sequence. A product hides a module or a row purely by not listing it here; there
// is no separate flag or exclusion list anywhere in the design.
export const panelpunchesPermissionCatalog: PermissionCatalog = [
  {
    label: 'Super Admin',
    permissions: [appShellPermissions.superAdmin],
  },
  {
    label: 'App Admin',
    permissions: [appShellPermissions.admin.canAccess],
  },
  {
    label: 'Store Admin Site',
    permissions: [panelpunchesPermissions.storeBack.canAccess],
  },
  {
    label: 'Store Web Site',
    permissions: [panelpunchesPermissions.storeFront.canAccess],
  },
  {
    label: 'Admin Mobile',
    permissions: [panelpunchesPermissions.adminMobile.canAccess],
  },
  {
    label: 'Blogs',
    permissions: [blogPermissions.canView, blogPermissions.canEdit, blogPermissions.canDelete],
  },
  {
    label: 'Product',
    permissions: [productPermissions.canView, productPermissions.canEdit, productPermissions.canDelete],
  },
  {
    label: 'Sales',
    permissions: [orderPermissions.canView, orderPermissions.canEdit],
  },
  {
    label: 'Returns',
    permissions: [returnOrderPermissions.canView, returnOrderPermissions.canEdit, returnOrderPermissions.canDelete],
  },
  {
    label: 'Purchase Order',
    permissions: [purchaseOrderPermissions.canView, purchaseOrderPermissions.canEdit],
  },
  {
    label: 'Customer',
    // PanelPunches has never offered customer delete — only canView/canEdit are composed
    // here, even though the shared pool also carries canDelete for hauler to compose.
    permissions: [customerPermissions.canView, customerPermissions.canEdit],
  },
  {
    label: 'Projects',
    permissions: [projectPermissions.canView, projectPermissions.canEdit, projectPermissions.canDelete],
  },
  {
    label: 'Conversation',
    permissions: [chatPermissions.canView, chatPermissions.canEdit],
  },
  {
    label: 'Reports',
    permissions: [appShellPermissions.reports.canView],
  },
  {
    label: 'History',
    permissions: [appShellPermissions.history.canView],
  },
  {
    label: 'Settings',
    permissions: [appShellPermissions.setting.canView, appShellPermissions.setting.canEdit],
  },
  {
    label: 'AI',
    permissions: [aiPermissions.canAccessMcp, aiPermissions.canManageAiBilling],
  },
]
